import React, { useState, useEffect } from 'react';
import { MainWrapper } from './style';
import policesObject from '../../polices.json';
import { useQuery } from 'store/useQuery';
import CotacaoService from 'services/CotacaoService';
import LeftMessage from '../LeftMessage';
import Acceptance from '../Acceptance';
import LoadingOrErrorPanel from 'components/LoadingOrErrorPanel';
import { NotificationManager } from 'react-notifications';
import { MessagesDefaultTimeout } from 'constants/messagesDefaultTimeout';
import { DefaultMessagesNotification } from 'constants/notificationMessage';
import CONSTANTES_AMBIENTE from 'constants/constantesAmbiente';

function Main() {
  const [licenses, setLicenses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(null);
  const [reasons, setReasons] = useState([]);
  const { queryParams } = useQuery();

  useEffect(() => {
    ListarMotivosReprovacao();
  }, []);

  useEffect(() => {
    if (queryParams.linhaServico === 'basico') {
      ObterCotacao();
    } else {
      // setLicenses(usersArray);
    }
  }, [queryParams]);

  async function ListarMotivosReprovacao(){
    const reasons = await CotacaoService.ListarMotivosReprovacao();
    const formattedReasons = reasons.map(reason => {
      return {
        id: reason.valor,
        reason: reason.nome
      }
    })
    setReasons(formattedReasons);
  }

  async function ObterCotacao() {
    setHasError(false)
    setLoading(true)
    const quote = await CotacaoService.ObterCotacao(queryParams.cotacao)
      .then(response=>{
        setLoading(false)
        return response;
      })
      .catch(error=>{
        setLoading(false)
        setHasError(true)
        NotificationManager.error(error.response?.data?.erros[0] || DefaultMessagesNotification.ErrorBodyGetData, 'Ocorreu um erro!', MessagesDefaultTimeout.Error);
        return null;
      });
    if(quote == null) return;
    
    if(quote.statusProvisionamentoLicencas != CONSTANTES_AMBIENTE.COTACAO_STATUS_PROVISIONAMENTO_LICENCAS.EMAPROVACAO){
      NotificationManager.error("A cotação não está com o Status igual a 'Em Aprovação'.", 'Ocorreu um erro!', MessagesDefaultTimeout.Error);
      setHasError(true)
      return;
    }

    const licensesArray = quote.linhasCotacao.map(license => ({
      id: license.linhaCotacaoId,
      name: license.nome,
      period: license.unidade?.vigencia,
      frequency: license.unidade?.periodicidadeFaturamento,
      price: license.precoPorUnidade,
      quantity: license.quantidade
    }))

    setLicenses(licensesArray);
  }

  return (
    <MainWrapper>
      <div className="container">
        <LeftMessage name={queryParams.name} />
        <LoadingOrErrorPanel loading={loading} hasError={hasError} hidePrecisoSuporte={true}>
          <Acceptance
            licenses={licenses}
            queryParams={queryParams}
            polices={policesObject}
            reasons={reasons}
          />
        </LoadingOrErrorPanel>
      </div>
    </MainWrapper>
  )
}


export default Main